// extracted by mini-css-extract-plugin
export var label = "_c8-2";
export var slideContainer = "_c8-0";
export var slider = "_c8-1";